import Swiper from 'swiper';
import { Grid, Navigation } from 'swiper/modules';

function sliderResults() {
  new Swiper('.swiper-results', {
    modules: [Navigation, Grid],
    grabCursor: true,
    spaceBetween: 10,
    navigation: {
      nextEl: ".results__slider .swiper-button-next",
      prevEl: ".results__slider .swiper-button-prev",
    },
    breakpoints: {
      600: {
        spaceBetween: 10,
        slidesPerView: 2,
        grid: {
          fill: "row",
          rows: 3,
        },
      },
      1110: {
        spaceBetween: 24,
        slidesPerView: 3,
        grid: {
          fill: "row",
          rows: 2,
        },
      }
    }
  });
}
sliderResults();